export const tagText = {
  JP: {
    drone: "ドローン撮影",
    camera: "一眼レフ撮影",
    underwater: "水中撮影",
    location: "ロケ地確保",
    model: "モデル手配",
    pickup: "送迎あり",
    private: "貸切プライベート",
    secret: "秘境スポット",
    starry: "星空撮影",
    boat: "ボート撮影",
    snorkel: "シュノーケル",
    turtleSnorkel: "海亀シュノーケル",
    sup: "SUP",
    emptyHand: "手ぶらOK",
    surfing: "サーフィン",
    jet: "ジェットツアー",
  },

  EN: {
    drone: "Drone",
    camera: "Photography",
    underwater: "Underwater",
    location: "Location",
    model: "Model",
    pickup: "Pickup",
    private: "Private",
    secret: "Hidden Spot",
    starry: "Starry Sky",
    boat: "Boat",
    snorkel: "Snorkeling",
    turtleSnorkel: "Sea Turtle",
    sup: "SUP",
    emptyHand: "No Gear Needed",
    surfing: "Surfing",
    jet: "Jet Tour",
  },

  中文: {
    drone: "无人机",
    camera: "摄影",
    underwater: "水下摄影",
    location: "场地安排",
    model: "模特安排",
    pickup: "接送",
    private: "私人",
    secret: "秘境",
    starry: "星空",
    boat: "船",
    snorkel: "浮潜",
    turtleSnorkel: "海龟浮潜",
    sup: "SUP",
    emptyHand: "无需装备",
    surfing: "冲浪",
    jet: "水上摩托",
  },

  한국어: {
    drone: "드론",
    camera: "사진",
    underwater: "수중촬영",
    location: "촬영지",
    model: "모델",
    pickup: "픽업",
    private: "프라이빗",
    secret: "비밀 명소",
    starry: "별하늘",
    boat: "보트",
    snorkel: "스노클링",
    turtleSnorkel: "거북이 스노클링",
    sup: "SUP",
    emptyHand: "빈손 OK",
    surfing: "서핑",
    jet: "제트 투어",
  },
};
